import React from "react"
import "./about.css"
import Back from "../common/back/Back"
import AboutCard from "./AboutCard"
import AboutFirst from "./AboutFirst"
import Home from "./Home"
import Hpartners from "./Hpartners"


const About = () => {
  return (
    <>
    <Home/>
    <AboutFirst/>
    <Hpartners/>
    
    </>
  )
}

export default About
